export default "__VITE_ASSET__snwlE6Oa__"